import { selectClippingBoxEnabledForSheetCadAlignment } from "@/store/modes/sheet-cad-alignment-mode-selectors";
import { setClippingBoxEnabled } from "@/store/modes/sheet-cad-alignment-mode-slice";
import { useAppDispatch, useAppSelector } from "@/store/store-hooks";
import { ViewDiv } from "@faro-lotv/app-component-toolbox";
import {
  ClippingBoxIcon,
  ToolButton,
  ToolGroup,
  grey,
} from "@faro-lotv/flat-ui";
import { Box, Stack, Toolbar, Tooltip } from "@mui/material";
import type { JSX } from "react";
import { useOverlayElements, useOverlayRef } from "../overlay-elements-context";
import { SheetCadAlignmentSetElevationPanel } from "./sheet-cad-alignment-set-elevation-panel";

/**
 * SheetCadAlignmentElevation provides a view for interacting with a 3D model
 * It also renders a panel for setting elevation in a sheet-to-CAD alignment tool and a button to enable/disable a clipping box.
 *
 * @returns A layout with a panel to set elevation and a 3D model view with a toolbar
 * for interacting with the model.
 */
export function SheetCadAlignmentElevation(): JSX.Element {
  const dispatch = useAppDispatch();

  const { setSingleScreen } = useOverlayElements();
  const singleScreenRef = useOverlayRef(setSingleScreen);

  const isClippingBoxEnabled = useAppSelector(
    selectClippingBoxEnabledForSheetCadAlignment,
  );

  return (
    <Stack direction="row" sx={{ height: "100%" }}>
      <SheetCadAlignmentSetElevationPanel />

      <ViewDiv
        eventDivRef={singleScreenRef}
        sx={{
          height: "100%",
          width: "100%",
        }}
      >
        <Box
          component="div"
          sx={{
            position: "absolute",
            height: "100%",
            width: "50px",
            right: "5px",
            alignContent: "center",
          }}
        >
          <Toolbar
            sx={{
              right: "25px",
            }}
          >
            <ToolGroup>
              <Tooltip title="Clip 3D model" placement="left">
                <ToolButton
                  sx={{ backgroundColor: grey[1000] }}
                  selected={isClippingBoxEnabled}
                  onClick={() => {
                    dispatch(setClippingBoxEnabled(!isClippingBoxEnabled));
                  }}
                >
                  <ClippingBoxIcon sx={{ width: "24px", height: "24px" }} />
                </ToolButton>
              </Tooltip>
            </ToolGroup>
          </Toolbar>
        </Box>
      </ViewDiv>
    </Stack>
  );
}
